//Source: https://www.taniarascia.com/websockets-in-redux/

import { subscribeToSSE, unsubscribeFromSSE } from 'utils/serverSendEventHelpers';

export const airMeshMiddleware = () => parameters => next => action => {
	const { type } = action;
	const { dispatch } = parameters;

	switch (type) {
		case 'airMesh/connect': {
			// Reset connection states before attempting new connection
			dispatch(unsubscribeFromSSE());
			dispatch(subscribeToSSE());
			break;
		}
		case 'airMesh/disconnect': {
			dispatch(unsubscribeFromSSE());
			break;
		}
		default: {
			break;
		}
	}

	return next(action);
};

export const airMeshConnect = payload => ({ type: 'airMesh/connect', payload });
export const airMeshDisconnect = () => ({ type: 'airMesh/disconnect' });
